module.exports = __webpack_public_path__ + "static/media/ChineseNY11_02.16dd65be.jpg";